import { gridSizeMdLg6, texto, TipoIdentificacionEnumChoice } from "@/shared";
import ImageUploadComponente from "@/shared/components/ui/UploadImage/ImageUploadComponente";
import { IContentUpdateClientFormType, Contrato, PaymentMethodEnum } from "@/shared/interfaces";
import { Edit } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

interface DatosFotosActualizarProps {
  contract?: Contrato;
  form: any; // PERF: UseFormReturn<IContentUpdateClientFormType> instanciaba Path<T> caro en el tsc

  imgCedulaFrontal: File | null,
  setImgCedulaFrontal: React.Dispatch<React.SetStateAction<File | null>>,

  imgCedulaReverso: File | null,
  setImgCedulaReverso: React.Dispatch<React.SetStateAction<File | null>>,

  imgCuentaBancaria: File | null,
  setCuentaBancaria: React.Dispatch<React.SetStateAction<File | null>>,

  imgTarjeta: File | null,
  setImgTarjeta: React.Dispatch<React.SetStateAction<File | null>>,

  imgRUC: File | null,
  setImgRUC: React.Dispatch<React.SetStateAction<File | null>>,

  imgRUCNombramiento: File | null,
  setImgRUCNombramiento: React.Dispatch<React.SetStateAction<File | null>>,
}

export default function DatosFotosActualizar({
  form,
  imgCedulaFrontal, setImgCedulaFrontal,
  imgCedulaReverso, setImgCedulaReverso,
  imgCuentaBancaria, setCuentaBancaria,
  imgTarjeta, setImgTarjeta,
  imgRUC, setImgRUC,
  imgRUCNombramiento, setImgRUCNombramiento

}: DatosFotosActualizarProps) {


  return (
    <>
      <Grid item {...gridSizeMdLg6}>
        <ImageUploadComponente
          buttonText={texto.cargar_cedula}
          selectedImage={imgCedulaFrontal}
          setSelectedImage={setImgCedulaFrontal}
          idInput={'cedula-frontal'}
          imageUrl={form.getValues().url_foto_identificacion_delantera}
          onClickTrash={() => {
            form.setValue('url_foto_identificacion_delantera', '');
          }}
          ///*Edit
          canDelete={false}
          endIcon={<Edit />}
          enablePreview={true}
        />
      </Grid>

      <Grid item {...gridSizeMdLg6}>
        <ImageUploadComponente
          buttonText={texto.cargar_cedula_reverso}
          selectedImage={imgCedulaReverso}
          setSelectedImage={setImgCedulaReverso}
          idInput={'cedula-reverso'}
          imageUrl={form.getValues().url_foto_identificacion_posterior}
          onClickTrash={() => {
            form.setValue('url_foto_identificacion_posterior', '');
          }}
          ///*Edit
          canDelete={false}
          endIcon={<Edit />}
          enablePreview={true}
        />
      </Grid>


      {
        form.getValues().codigo_forma_pago === PaymentMethodEnum.DEBITO && (
          <Grid item {...gridSizeMdLg6}>
            <ImageUploadComponente
              buttonText={texto.respaldo_pago}
              selectedImage={imgCuentaBancaria}
              setSelectedImage={setCuentaBancaria}
              idInput={'respaldo-preventa'}
              imageUrl={form.getValues().url_foto_cuenta_bancaria ?? ''}
              onClickTrash={() => {
                form.setValue('url_foto_cuenta_bancaria', '');
              }}

              ///*Edit
              canDelete={false}
              endIcon={<Edit />}
              enablePreview={true}
            />
          </Grid>
        )
      }

      {
        form.getValues().codigo_forma_pago === PaymentMethodEnum.TARJETA && (
          <Grid item {...gridSizeMdLg6}>
            <ImageUploadComponente
              buttonText={texto.foto_tarjeta}
              selectedImage={imgTarjeta}
              setSelectedImage={setImgTarjeta} idInput={'tarjeta-preventa'}
              imageUrl={form.getValues().url_foto_tarjeta ?? ''}
              onClickTrash={() => {
                form.setValue('url_foto_tarjeta', '');
              }}

              ///*Edit
              canDelete={false}
              endIcon={<Edit />}
              enablePreview={true}
            />
          </Grid>
        )
      }

      {
        form.getValues().tipo_identificacion == TipoIdentificacionEnumChoice.RUC && (
          <>
            <Grid item {...gridSizeMdLg6}>
              <ImageUploadComponente
                buttonText={'Cargar RUC'}
                selectedImage={imgRUC}
                setSelectedImage={setImgRUC} idInput={'ruc-preventa'}
                imageUrl={form.getValues().url_foto_ruc ?? ''}
                onClickTrash={() => {
                  form.setValue('url_foto_ruc', '');
                }}

                ///*Edit
                canDelete={false}
                endIcon={<Edit />}
                enablePreview={true}
              />
            </Grid>

            <Grid item {...gridSizeMdLg6}>
              <ImageUploadComponente
                buttonText={'Cargar Nombramiento'}
                selectedImage={imgRUCNombramiento}
                setSelectedImage={setImgRUCNombramiento} idInput={'ruc-nombramiento'}
                imageUrl={form.getValues().url_foto_nombramiento ?? ''}
                onClickTrash={() => {
                  form.setValue('url_foto_nombramiento', '');
                }}
                ///*Edit
                canDelete={false}
                endIcon={<Edit />}
                enablePreview={true}
              />
            </Grid>
          </>
        )
      }

    </>
  )

}